module.exports = __webpack_public_path__ + "static/img/Funiture PU products application horizontal_desktop.aa84cb28.jpg";